module.exports = __webpack_public_path__ + "static/img/zheda.6583fe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zheda.png
// module id = ZWzf
// module chunks = 0